/* CSS Overriding issue https://github.com/css-modules/css-modules/issues/195#issuecomment-676351428 */
@font-face {
  font-family: 'Kohinoor';
  src: url('../../../public/fonts/KohinoorBangla/KohinoorBangla-Regular.otf');
}
.text {
  font-family: 'Lato', 'Open Sans', 'Lucidia Grande', 'Roboto', sans-serif;
  font-stretch: expanded;
}

.number {
  font-family: 'Kohinoor', 'Gentium Book Plus', 'Lucidia Grande', 'Roboto', sans-serif;
  letter-spacing: 0.02rem;
  font-weight: 500;
}

.cursive {
  letter-spacing: 0.02rem;
  font-family: 'Alkatra', 'Lato';
}
